/**
 * @generated SignedSource<<e27d7c19fb7e600bee73a36be4bf8e92>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type aiStudioContentEnvironmentQuery$variables = {
  productId: string;
};
export type aiStudioContentEnvironmentQuery$data = {
  readonly model: {
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
};
export type aiStudioContentEnvironmentQuery = {
  response: aiStudioContentEnvironmentQuery$data;
  variables: aiStudioContentEnvironmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiStudioContentEnvironmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiStudioContentEnvironmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2031c21ba5422ea40ea74f7f430da85f",
    "id": null,
    "metadata": {},
    "name": "aiStudioContentEnvironmentQuery",
    "operationKind": "query",
    "text": "query aiStudioContentEnvironmentQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    zakekeEnvironment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3fb4ae7aed5fb6ac89f893e6ba0ccc8";

export default node;
